<template>
    <div
        v-if="isLocked"
        class="
            z-[10000]
            fixed
            top-0
            left-0
            w-full
            h-full
            flex
            items-center
            justify-center
            p-8
            bg-black bg-opacity-75
            backdrop-blur-md
            text-white text-2xl
            flex-col
            gap-8
        "
    >
        <ion-icon name="phone-portrait-outline" class="rotate-anim"></ion-icon>
        Please rotate your device to landscape orientation to view the
        whiteboard

        <div class="flex items-center gap-4">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";

const isOrientationPortrait = () => {
    return screen.orientation.type.includes("portrait");
};

const isLocked = ref(false);

onMounted(() => {
    // listen to orientation changes
    window.addEventListener("orientationchange", () => {
        isLocked.value = isOrientationPortrait();
    });
    window.addEventListener("resize", () => {
        isLocked.value = isOrientationPortrait();
    });
    isLocked.value = isOrientationPortrait();
});
</script>

<style scoped>
.rotate-anim {
    animation: rotate-landscape 1s infinite;
    font-size: 48px;
}

@keyframes rotate-landscape {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(90deg);
    }
}
</style>
